import $ from "jquery";
import "free-jqgrid";

function createWrapper(element: HTMLElement) {
    function create(options: FreeJqGrid.JqGridOptions) {
        $(element).jqGrid(options);
    }

    function clear() {
        $(element).jqGrid("clearGridData", undefined);
    }

    function setLabel(colName: string, newLabel: string, newClass?: string) {
        $(element).jqGrid("setLabel", colName, newLabel, newClass);
    }

    function addRow(id: string, data: object | object[]) {
        $(element).jqGrid("addRowData", id, data);
    }

    function getRowData(id: string) {
        return $(element).jqGrid("getRowData", id);
    }

    function showColumn(columnId: string) {
        $(element).jqGrid("showCol", [columnId]);
    }

    function showColumns(columnIds: string[]) {
        $(element).jqGrid("showCol", columnIds);
    }

    function hideColumn(columnId: string) {
        $(element).jqGrid("hideCol", [columnId]);
    }

    function hideColumns(columnIds: string[]) {
        $(element).jqGrid("hideCol", columnIds);
    }

    function setGridHeight(newHeight: number | "auto" | "100%" | string) {
        $(element).jqGrid("setGridHeight", newHeight);
    }

    function setSelection(id: string) {
        return $(element).jqGrid("setSelection", id, false, undefined);
    }

    function getRows() {
        return $(element).jqGrid("getRowData");
    }

    return {
        create: create,
        clear: clear,
        addRow: addRow,
        showColumn: showColumn,
        showColumns: showColumns,
        hideColumn: hideColumn,
        hideColumns: hideColumns,
        setGridHeight: setGridHeight,
        getRowData: getRowData,
        setSelection: setSelection,
        setLabel: setLabel,
        getRows: getRows
    };
}

export default {
    createWrapper: createWrapper
};
